import { DateTime } from 'luxon';

export class QueryResult {
    public count: number;
    public query: string;
    public header: { [key: string]: any };
    public results: Array<{ [key: string]: any }>;
    public timestamp: DateTime;
}
